module.exports = __webpack_public_path__ + "images/avatars/male/2.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/male/2.svg
// module id = T2uR
// module chunks = 151